// extracted by mini-css-extract-plugin
module.exports = {"dropGuide":"DropGuide_dropGuide__UAEFY","dropGuideIcon":"DropGuide_dropGuideIcon__9VZrx"};